module.exports = __webpack_public_path__ + "img/control.f938f342.png";